const indexItems = [
  { letter: 'A', items: '暗夜追踪者 · 爱在星光下 · 暗黑纪元' },
  { letter: 'B', items: '不败传说 · 冰封王座 · 白发魔女传' },
  { letter: 'C', items: '重生之都市修仙 · 传说之下 · 超级英雄联盟' },
  { letter: 'D', items: '斗罗传奇 · 大主宰 · 帝王之路' },
  { letter: 'F', items: '凡人修仙传 · 风起苍岚 · 凤囚凰' },
  { letter: 'G', items: '宫廷秘史 · 古剑奇谭 · 鬼灭之魂' },
  { letter: 'H', items: '洪荒纪元 · 幻城 · 火影新篇' },
  { letter: 'L', items: '恋爱幻想曲 · 灵笼 · 龙族传说' },
  { letter: 'M', items: '魔导纪元 · 冒险王 · 魔法学徒' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">漫画索引</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">妖精漫画网大全完整索引，按首字母快速查找你喜欢的漫画作品</p>
        </div>
        <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.letter}
              href="#cards"
              className="block bg-background-50 rounded-2xl p-5 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/30 transition-all group"
            >
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-secondary-100 text-secondary-700 font-heading text-sm mb-3">
                {item.letter}
              </span>
              <p className="text-xs text-foreground-600 leading-relaxed group-hover:text-foreground-800">
                {item.items}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}